"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChipImage = void 0;
var _react = _interopRequireDefault(require("react"));
var _index = require("../Image/index.js");
var _index2 = require("../../styles/index.js");
var ChipImage = exports.ChipImage = function ChipImage(_ref) {
  var src = _ref.src,
    size = _ref.size;
  var imgSize = size === 'small' ? (0, _index2.cssGraphicSize)('base', 'decorative', '24px') : (0, _index2.cssGraphicSize)('larger', 'decorative', '32px');
  return /*#__PURE__*/_react["default"].createElement(_index.Image, {
    src: src,
    crop: true,
    circle: true,
    imageHeight: imgSize,
    imageWidth: imgSize,
    alt: ""
  });
};